import { SignatureInput, ModalNormal, CustomInput } from '@/shared/ui/components';
import classNames from 'classnames';
import { t } from 'ttag';
import { useEditReportModal } from './useEditReportModal';
import type { EditReportModalProps } from './editReportModal.types';
import './editReportModal.scss';

const EditReportModal = ({
  physicianInterpretation,
  signature,
  header,
  isNewFormat,
  formatVersion,
  isUploadedAiReport,
  isUploadedArcsReport,
  isInstantReport,
  isEventReport,
  isNotificationReport,
  isInterimReport,
  profile,
  handleClickAddComment,
  handleClickAddSignature,
  isSaving,
  isOpen,
  toggle,
  isNewNotiEventReport,
}: EditReportModalProps) => {
  const { state, onChangePhysicianInterpretation, onEndSignature, handleClick } =
    useEditReportModal({
      physicianInterpretation,
      signature,
      header,
      isNewFormat,
      formatVersion,
      isUploadedAiReport,
      isUploadedArcsReport,
      isInstantReport,
      isEventReport,
      isNotificationReport,
      isInterimReport,
      profile,
      handleClickAddComment,
      handleClickAddSignature,
      isOpen,
      isNewNotiEventReport,
    });

  /**
   * Renders the body of the edit-report modal, which asks either for an interpretation or for a signature. Shows the physician interpretation textarea when state.isCommentInput is set and otherwise the signature drawing pad, disabling both while a save is in flight.
   *
   * @returns The modal body markup.
   */
  const renderChildren = () => (
    <div className="custom-modal-body-container">
      {state.isCommentInput ? (
        <CustomInput
          className="physician-interpretation"
          placeholder="Enter interpretation..."
          type="textarea"
          value={state.physicianInterpretation}
          onChange={onChangePhysicianInterpretation}
          disabled={isSaving}
          name="physicianInterpretation"
        />
      ) : (
        <SignatureInput
          title={t`Kindly provide your signature by drawing it below.`}
          disabled={isSaving}
          signature={state.signature}
          onEndSignature={onEndSignature}
        />
      )}
    </div>
  );

  return (
    <ModalNormal
      className={classNames('edit-report-modal', state.isCommentInput && 'comment-report')}
      title={header}
      visible={isOpen}
      submitButtonName={
        header === 'Physician interpretation'
          ? t`Add Interpretation`
          : header === 'Update findings'
            ? t`Save`
            : t`Sign & Save`
      }
      handleSubmit={handleClick}
      loading={isSaving}
      disableCancelButton={isSaving}
      handleCancel={
        isSaving
          ? undefined
          : () => {
              toggle();
            }
      }
      disableSubmitButton={state.isCommentInput ? false : !state.signature}
    >
      {renderChildren()}
    </ModalNormal>
  );
};

export default EditReportModal;
